import React, { Component } from 'react'
import CouncillorPage from '../../components/CouncillorPage'
import councillors from '../../data/toronto/councillors.json'
import cityCouncil from '../../data/toronto/cityCouncil.json'

type Props = {
  match: {
    params: {
      councillorId: string
    }
  }
}

class TorontoCouncillor extends Component<Props> {
  render() {
    const {
      match: {
        params: {
          councillorId
        }
      }
    } = this.props

    const councillor = councillors[councillorId]

    return (
      <CouncillorPage
        averageAttendanceRate={cityCouncil.averageAttendanceRate}
        secretMeetingsRateAverage={cityCouncil.secretMeetingsRateAverage}
        numberOfPeoplePerCouncillor={cityCouncil.numberOfPeoplePerCouncillor}
        {...councillor}
      />
    )
  }
}

export default TorontoCouncillor



// WEBPACK FOOTER //
// ./src/containers/TorontoCouncillor/TorontoCouncillor.js